import App from "./recipes/App.svelte"
import Preparation from "./recipes/Preparation.svelte"
import Public from "./recipes/Public.svelte"

let recipeApp
let preparationApp
let publicRecipeApp

const mountRecipeApp = () => {
  destroyRecipeApp()

  const root = document.querySelector("#recipe-app")

  if (root === null) return

  // Wipe any DOM left behind by a Turbo cache restore (Svelte's async outro
  // transitions can be snapshotted by turbo:before-cache, leaving a baked copy).
  root.innerHTML = ""

  const initialData = JSON.parse(root.dataset.initialData)

  recipeApp = new App({
    target: root,
    props: {
      initialData
    }
  })
}

const destroyRecipeApp = () => {
  if (recipeApp) {
    recipeApp.$destroy()
    recipeApp = null
  }
}

const mountPreparationApp = () => {
  destroyPreparationApp()

  const root = document.querySelector("#recipe-preparation-app")

  if (root === null) return

  root.innerHTML = ""

  const initialData = JSON.parse(root.dataset.initialData)

  preparationApp = new Preparation({
    target: root,
    props: {
      initialData
    }
  })
}

const destroyPreparationApp = () => {
  if (preparationApp) {
    preparationApp.$destroy()
    preparationApp = null
  }
}

const mountPublicRecipeApp = () => {
  destroyPublicRecipeApp()

  const root = document.querySelector("#public-recipe-app")

  if (root === null) return

  root.innerHTML = ""

  const initialData = JSON.parse(root.dataset.initialData)

  publicRecipeApp = new Public({
    target: root,
    props: {
      initialData
    }
  })
}

const destroyPublicRecipeApp = () => {
  if (publicRecipeApp) {
    publicRecipeApp.$destroy()
    publicRecipeApp = null
  }
}

const mount = () => {
  mountRecipeApp()
  mountPreparationApp()
  mountPublicRecipeApp()
}

const destroy = () => {
  destroyRecipeApp()
  destroyPreparationApp()
  destroyPublicRecipeApp()
}

document.addEventListener("turbo:load", mount)
document.addEventListener("turbo:before-cache", destroy)
